// MST1020_R01 BOM 관련 유틸리티 함수 및 상수

import { allowedAccountsArr } from "src/components/common/common";
import { MST1020_R01_BomDto } from "./Dto_MST1020_R01";
import { showWarning } from "src/utils/toast/toastUtil";

// BOM 컬럼 헤더명
export const headerNames: Record<string, string> = {
  rowIndex: "",
  prntItemcd: '모품목코드',
  prntItemnm: '모품목명',
  childItemcd: '자품목코드',
  childItemnm: '자품목명',
  itemSpec: '규격',
  bomSeq: '순번',
  bomUseyn: '사용여부',
  prntItemQty: '모품목수량',
  prntItemUnit: '모품목단위',
  childItemUsage: '소요량',
  childItemUnit: '자품목단위',
  fixLossqty: '고정손실량',
  lossPercent: '손실율(%)',
  applyBeginDt: '적용시작일',
  applyEndDt: '적용종료일',
  remark: '비고'
};

// 원본 데이터 복구 함수
export function restoreOriginalValues(
  valueIndex: number,
  originalData: MST1020_R01_BomDto,
  updateMST1020_R01Bom: (index: number, data: MST1020_R01_BomDto) => void,
  gridRef: any
) {
  setTimeout(() => {
    updateMST1020_R01Bom(valueIndex, {
      ...originalData,
      bomUpdateNo: originalData.bomUpdateNo || '1',
      isModified: originalData.inserted === true ? false : true
    });
    if (gridRef.current?.api) {
      const allRowNodes: any[] = [];
      gridRef.current.api.forEachNode((node: any) => {
        if (node.data && node.data.valueIndex === valueIndex) {
          allRowNodes.push(node);
        }
      });
      if (allRowNodes.length > 0) {
        const targetNode = allRowNodes[0];
        targetNode.setDataValue('childItemcd', originalData.childItemcd);
        targetNode.setDataValue('childItemnm', originalData.childItemnm);
        targetNode.setDataValue('itemSpec', originalData.itemSpec);
        targetNode.setDataValue('locationCd', originalData.locationCd ?? '');
        targetNode.setDataValue('locationNm', originalData.locationNm ?? '');
        targetNode.setDataValue('childItemUnit', originalData.childItemUnit);
      }
    }
  }, 100);
}

// 행 편집 가능 여부
export function isEditableRow(
  params: any,
  originalMST1020_R01BomList: MST1020_R01_BomDto[],
  deletedMST1020_R01BomDetailList: (string | number)[]
): boolean {
  if (params.data?.inserted) return true;
  const originalData = originalMST1020_R01BomList.find(item => item.valueIndex === params.data?.valueIndex);
  const originalBomUseyn = originalData?.bomUseyn || 'N';
  if (originalBomUseyn === 'N') return false;
  if (params.data?.childItemcd && deletedMST1020_R01BomDetailList.includes(params.data.childItemcd)) return false;
  return true;
}

// 날짜 컬럼 클릭 시 편집 가능 여부
export function validateDateColumns(
  field: string,
  data: any,
  originalMST1020_R01BomList: MST1020_R01_BomDto[],
  dateColumns: string[]
): boolean {
  const originalData = originalMST1020_R01BomList.find(item => item.valueIndex === data.valueIndex);
  const originalBomUseyn = originalData?.bomUseyn || 'N';
  return dateColumns.includes(field) && originalBomUseyn !== 'N';
}

// 품목 계정 검증
export function validateItemAccount(itemAccount: string) {
  return allowedAccountsArr.includes(itemAccount);
}

// 중복 체크
export function isDuplicateChildItemcd(
  list: MST1020_R01_BomDto[],
  itemCd: string,
  valueIndex: number
) {
  return list.filter(item => item.childItemcd === itemCd && item.valueIndex !== valueIndex).length > 0;
}

// 손실율/필요수량 자동 계산 로직은 제거되었습니다.